export default __webpack_public_path__ + "static/media/good-year.9d623429.png";